import { render, staticRenderFns } from "./postYoutube.vue?vue&type=template&id=2c1fcaec"
import script from "./postYoutube.vue?vue&type=script&lang=js"
export * from "./postYoutube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1fcaec')) {
      api.createRecord('2c1fcaec', component.options)
    } else {
      api.reload('2c1fcaec', component.options)
    }
    module.hot.accept("./postYoutube.vue?vue&type=template&id=2c1fcaec", function () {
      api.rerender('2c1fcaec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/postYoutube.vue"
export default component.exports